module.exports = "data:video/mp4;base64,"